<div
  class="w-full max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 sm:pt-8 pb-8"
  data-onboarding="home-hero"
>
  <div
    class="mt-3 md:mt-0 md:bg-transparent md:dark:bg-transparent md:border-0 md:dark:border-0 md:shadow-none md:dark:shadow-none md:rounded-none rounded-[1.75rem] border border-white/80 dark:border-white/8 bg-white/90 dark:bg-[var(--color-dark-bg-secondary)]/92 shadow-[0_20px_45px_rgba(15,23,42,0.08)] px-4 py-5 md:p-0">
  <div class="flex justify-center mb-6 md:mb-6">
    <span
      class="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#F3F4F6] dark:bg-[var(--color-dark-bg-secondary)] text-xs font-bold text-[#3D3DF4] dark:text-[#5D5DF6] uppercase tracking-wider">
      <span class="w-2 h-2 bg-green-500 rounded-full"></span>
      Inteligencia Activa
    </span>
  </div>

  <h1 class="text-center text-[1.95rem] sm:text-3xl lg:text-4xl font-semibold text-gray-900 dark:text-white mb-4 md:mb-8 leading-[1.08]">
    <span class="text-gray-900 dark:text-white">Hola, {{ userName }}.</span>
    <span class="text-gray-400 dark:text-gray-300"> ¿Qué analizamos hoy?</span>
  </h1>

  <p class="md:hidden text-center text-sm leading-6 text-gray-500 dark:text-gray-400 mb-5">
    Empieza con una consulta rápida o elige una sugerencia para abrir una conversación con contexto.
  </p>

  <div class="max-w-2xl mx-auto mb-5 md:mb-6" data-onboarding="home-search">
    <div
      class="relative flex flex-col md:flex-row md:items-center bg-white dark:bg-[var(--color-dark-bg-secondary)] border border-gray-200 dark:border-gray-700 rounded-[1.4rem] shadow-sm p-2 md:p-0">
      <div class="flex items-center flex-1 min-w-0">
        <div class="pl-3 md:pl-5 pr-3 text-gray-400">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z">
          </path>
          </svg>
        </div>
        <input [ngModel]="chatMessage" (ngModelChange)="onChatMessageChange($event)" (keyup.enter)="onSend()" type="text"
          placeholder="Pregunta a tu agente..."
          class="flex-1 py-3.5 md:py-4 pr-2 bg-transparent border-none outline-none text-gray-900 dark:text-white placeholder-gray-400 text-sm min-w-0">
      </div>
      <button (click)="onSend()" [disabled]="!chatMessage || !chatMessage.trim()"
        class="mt-2 md:mt-0 md:mr-1.5 w-full md:w-auto justify-center px-5 py-3 md:px-6 md:py-2.5 bg-[#1F1F7A] hover:bg-[#3D3DF4] disabled:bg-gray-300 dark:disabled:bg-gray-600 text-white rounded-[1rem] text-sm font-medium transition-colors cursor-pointer disabled:cursor-not-allowed flex items-center gap-2">
        Consultar
        <img src="assets/images/send.svg" alt="" class="w-4 h-4">
      </button>
    </div>
  </div>

  @if (hasQuickPrompts && currentPrompt && nextPrompt) {
  <div class="flex gap-3 overflow-x-auto md:overflow-visible md:flex-wrap md:justify-center pb-1 -mx-4 px-4 md:mx-0 md:px-0 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
    <button (click)="onPromptSelected(currentPrompt)"
      class="shrink-0 min-w-[260px] md:min-w-[250px] px-4 py-3.5 bg-white dark:bg-[var(--color-dark-bg-secondary)] border border-gray-200 dark:border-gray-700 rounded-[1.15rem] text-sm text-gray-600 dark:text-white hover:border-[var(--color-brand-400)] hover:text-[var(--color-brand-500)] dark:hover:text-[var(--color-brand-300)] transition-opacity duration-700 cursor-pointer flex flex-col items-start"
      [class.opacity-30]="isPromptTransitioning" [class.opacity-100]="!isPromptTransitioning">
      <span class="text-sm font-medium">{{ currentPrompt.prompt }}</span>
      <span class="text-xs text-gray-500 dark:text-gray-400 mt-1">{{ currentPrompt.expert }}</span>
    </button>

    <button (click)="onPromptSelected(nextPrompt)"
      class="shrink-0 min-w-[260px] md:min-w-[250px] px-4 py-3.5 bg-white dark:bg-[var(--color-dark-bg-secondary)] border border-gray-200 dark:border-gray-700 rounded-[1.15rem] text-sm text-gray-600 dark:text-white hover:border-[var(--color-brand-400)] hover:text-[var(--color-brand-500)] dark:hover:text-[var(--color-brand-300)] transition-opacity duration-700 cursor-pointer flex flex-col items-start"
      [class.opacity-30]="isPromptTransitioning" [class.opacity-100]="!isPromptTransitioning">
      <span class="text-sm font-medium">{{ nextPrompt.prompt }}</span>
      <span class="text-xs text-gray-500 dark:text-gray-400 mt-1">{{ nextPrompt.expert }}</span>
    </button>
  </div>
  }
</div>
</div>
